/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CodeInteroperabilite } from './codeInteroperabilite';
import { ResultatRechercheDocumentsInnerAuteur } from './resultatRechercheDocumentsInnerAuteur';


export interface ResultatRechercheDocumentsInner { 
    uniqueId: string;
    title: string;
    description?: string;
    classCode: CodeInteroperabilite;
    typeCode: CodeInteroperabilite;
    dateCreation: string;
    dateDebutActe?: string;
    dateFinActe?: string;
    structureActivite: CodeInteroperabilite;
    cadreExercice: CodeInteroperabilite;
    /**
     * Date de d\'envoi du document
     */
    dateEnvoi?: string;
    uuid: string;
    statut: ResultatRechercheDocumentsInner.StatutEnum;
    /**
     * Est-ce que le document est visible par le patient
     */
    visiblePatient?: boolean;
    /**
     * Est-ce que le document est visible par les représentants légaux du patient
     */
    visibleRepresentantLegal?: boolean;
    /**
     * Est-ce que le document est visible par le professionnel de santé
     */
    visiblePS?: boolean;
    format: string;
    auteur?: ResultatRechercheDocumentsInnerAuteur;
}
export namespace ResultatRechercheDocumentsInner {
    export type StatutEnum = 'Validé' | 'Obsolète' | 'Archivé';
    export const StatutEnum = {
        Valid: 'Validé' as StatutEnum,
        Obsolte: 'Obsolète' as StatutEnum,
        Archiv: 'Archivé' as StatutEnum
    };
}


